<template>
    <div
        class="h-screen flex flex-col justify-center lg:block relative"
        :class="shouldScroll ? 'overflow-y-auto overflow-x-hidden' : 'overflow-hidden'"
    >
        <svg-icon type="logo" class="lg:absolute !w-120 !h-120 !lg:w-148 !lg:h-148 mx-auto"/>
        <router-view/>
    </div>
</template>

<script>

import SvgIcon from "../components/ui/SvgIcon.vue";
import {mapStores} from "pinia";
import {useMainStore} from "../state/store";

export default {
    components: {SvgIcon},
    head() {
        return {
            titleTemplate: 'Jobtoolz | %s',
        }
    },
    methods: {
        ...mapStores(useMainStore),
    },
    computed: {
        shouldScroll() {
            return ['suggest-two-factor', 'require-two-factor'].includes(this.$route.name)
        }
    },
    mounted() {
        document.querySelector('body').classList.remove('overflow-hidden');
        if (this.$route.query.lang) {
            this.mainStore.setLocale(this.$route.query.lang);
            this.$i18n.locale = this.$route.query.lang;
        }
    },
}
</script>

<style scoped>
</style>
